import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { ConfigProvider } from './context/ConfigContext';
import Navbar from './components/layout/Navbar';
import MobileNav from './components/layout/MobileNav';
import Home from './pages/Home';
import Quran from './pages/Quran';
import Hadith from './pages/Hadith';
import Duas from './pages/Duas';
import Books from './pages/Books';
import Profile from './pages/Profile';
import AdminPanel from './pages/admin/AdminPanel';
import Contact from './pages/Contact';
import SignIn from './pages/auth/SignIn';
import SignUp from './pages/auth/SignUp';
import ProtectedRoute from './components/auth/ProtectedRoute';
import './App.css';
import VerifyEmailNotice from './pages/auth/VerifyEmailNotice';
import VerifyEmail from './pages/auth/VerifyEmail';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

function App() {
    return (
        <ConfigProvider>
            <AuthProvider>
                <ThemeProvider>
                    <Router>
                        <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-50 dark:from-gray-900 dark:to-gray-800 transition-colors duration-300">
                            <Navbar />

                            <motion.main
                                className="pt-16"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ duration: 0.5 }}
                            >
                                <Routes>
                                    <Route path="/" element={<Home />} />
                                    <Route path="/quran" element={<Quran />} />
                                    <Route path="/hadith" element={<Hadith />} />
                                    <Route path="/duas" element={<Duas />} />
                                    <Route path="/books" element={<Books />} />

                                    {/* Only wrap SignIn, SignUp & Contact with GoogleReCaptchaProvider */}
                                    <Route
                                        path="/contact"
                                        element={
                                            <GoogleReCaptchaProvider
                                                reCaptchaKey={import.meta.env.VITE_RECAPTCHA_SITE_KEY}
                                                scriptProps={{ async: true, defer: true, appendTo: 'head' }}
                                            >
                                                <Contact />
                                            </GoogleReCaptchaProvider>
                                        }
                                    />
                                    <Route
                                        path="/signin"
                                        element={
                                            <GoogleReCaptchaProvider
                                                reCaptchaKey={import.meta.env.VITE_RECAPTCHA_SITE_KEY}
                                                scriptProps={{ async: true, defer: true, appendTo: 'head' }}
                                            >
                                                <SignIn />
                                            </GoogleReCaptchaProvider>
                                        }
                                    />
                                    <Route
                                        path="/signup"
                                        element={
                                            <GoogleReCaptchaProvider
                                                reCaptchaKey={import.meta.env.VITE_RECAPTCHA_SITE_KEY}
                                                scriptProps={{ async: true, defer: true, appendTo: 'head' }}
                                            >
                                                <SignUp />
                                            </GoogleReCaptchaProvider>
                                        }
                                    />
                                    
                                    <Route path="/verify-email-notice" element={<VerifyEmailNotice />} />
                                    <Route path="/verify-email" element={<VerifyEmail />} />
                                    <Route
                                        path="/profile"
                                        element={
                                            <ProtectedRoute>
                                                <Profile />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path="/admin/*"
                                        element={
                                            <ProtectedRoute requiredRole="admin">
                                                <AdminPanel />
                                            </ProtectedRoute>
                                        }
                                    />
                                </Routes>
                            </motion.main>

                            <MobileNav />
                            <Toaster position="top-center" />
                        </div>
                    </Router>
                </ThemeProvider>
            </AuthProvider>
        </ConfigProvider>
    );
}

export default App;